import { Plugin } from '@nuxt/types'
import LogRocket from 'logrocket'

const SENSITIVE_FIELDS = new Set([
  'first_name',
  'last_name',
  'email',
  'phone',
  'landline_phone',
  'birth_date',
  'salutation',
  'zip_code',
  'city',
  'street',
  'porting_mobile_number',
  'id_front_image',
  'id_back_image',
  'id_selfie_image',
  'file_front_side',
  'file_back_side',
  'file_selfie',
])

function sanitizeObject (obj: unknown): unknown {
  if (obj === null || obj === undefined) { return obj }
  if (Array.isArray(obj)) { return obj.map(sanitizeObject) }
  if (typeof obj === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
      result[key] = SENSITIVE_FIELDS.has(key) && value != null ? '[SANITIZED]' : sanitizeObject(value)
    }
    return result
  }
  return obj
}

function sanitizeBody (body: string | null | undefined): string | null | undefined {
  if (!body) { return body }
  try {
    return JSON.stringify(sanitizeObject(JSON.parse(body)))
  } catch {
    return body
  }
}

const logrocketPlugin: Plugin = ({ $config }) => {
  if ($config.LOGROCKET_IS_ENABLED && $config.LOGROCKET_APP_ID) {
    LogRocket.init($config.LOGROCKET_APP_ID, {
      dom: {
        inputSanitizer: 'lipsum',
      },
      network: {
        requestSanitizer (request) {
          return { ...request, body: sanitizeBody(request.body) }
        },
        responseSanitizer (response) {
          return { ...response, body: sanitizeBody(response.body) }
        },
      },
    })
  }
}

export default logrocketPlugin
